import * as React from 'react';
import Generator from '@Components/generator-v3';

const NicknameGenerator: React.FC = () => {
  return <Generator />;
};

export default NicknameGenerator;
